import React from 'react'

import { connect } from 'react-redux'
import Operations from '../../../operations'
import Selectors from '../../../selectors'

import {
  EmarModuleCard,
  FamilyPlanModuleCard,
  PaywallTemplate,
} from '@lmc/ui-kit'
import { colors } from '@lmc/common/constants'
import { IconType } from '@lmc/ui-kit'
import { Action } from 'redux'
import { colours } from '@lmc/ui-kit/src/config/theme'
import { Home, HomeSource } from '@lmc/ts-common'

interface StateProps {
  subscribeTo: () => void
  getSubscriptions: () => void
  subscriptionCancelled?: boolean
  role?: string
  preferredCarePlansNominative?: string
  source?: HomeSource
}

export const CarePlansPaywallComponent: React.FC<StateProps> = ({
  subscribeTo,
  getSubscriptions,
  subscriptionCancelled,
  role,
  preferredCarePlansNominative,
  source,
}) => {
  React.useEffect(() => {
    getSubscriptions()
  }, [])

  const ctaDisabled = role === 'senior-carer' || subscriptionCancelled
  let disabledText
  if (subscriptionCancelled) {
    disabledText = 'Note: Sorry, you have already completed a free trial.'
  } else if (role === 'senior-carer') {
    disabledText = 'Note: Only admins can start a free trial.'
  }

  return (
    <PaywallTemplate
      backgroundColor={colours.status.popout}
      title={preferredCarePlansNominative || ''}
      subTitle="Provide person-centred care and empower service users to sign their own care plan. Attach risk assessments and standardise the care plan format across the service."
      bodyText="Create personalised support plans in minutes."
      cta="Start Free Trial"
      onClick={subscribeTo}
      icon={IconType.CarePlansHexagon}
      videoUrl="https://www.youtube.com/embed/oSATUs33VR0"
      articles={[
        {
          title: 'How do I review a care plan?',
          subtitle: 'View Article',
          icon: 'SettingOutlined',
          id: 'testId1',
          link: 'https://support.logmycare.co.uk/en/articles/4741330-how-do-i-review-a-care-plan',
          iconBackgroundColour: colors.orange,
          iconColour: colors.white,
        },
        {
          title: 'How do I sign a care plan?',
          subtitle: 'View Article',
          icon: 'QuestionCircleOutlined',
          id: 'testId2',
          link: 'https://support.logmycare.co.uk/en/articles/5685192-how-do-i-sign-a-care-plan',
          iconBackgroundColour: colors.green,
          iconColour: colors.white,
        },
        {
          title: 'What other features do I get with Pro?',
          subtitle: 'View Article',
          icon: 'UserOutlined',
          id: 'testId3',
          link: 'https://support.logmycare.co.uk/en/collections/1681220-the-pro-plan',
          iconBackgroundColour: colors.purple,
          iconColour: colors.white,
        },
      ]}
      leftModuleCard={<EmarModuleCard />}
      rightModuleCard={<FamilyPlanModuleCard />}
      ctaDisabled={ctaDisabled}
      disabledText={disabledText}
      findOutMoreURL="https://logmycare.co.uk/features/care-delivery"
      customLinkText="Read more"
      source={source}
    />
  )
}

const mapStateToProps = (state: {
  global: { user: { role: unknown }; home: Home }
}) => ({
  subscriptionCancelled: Selectors.isSubscriptionCancelled(
    // @ts-ignore
    state,
    'pro-monthly'
  ),
  role: state.global?.user?.role,
  preferredCarePlansNominative:
    state.global?.home?.preferredCarePlansNominative,
  source: state.global?.home?.source,
})

const mapDispatchToProps = (dispatch: (param: Action<unknown>) => unknown) => ({
  subscribeTo: () =>
    dispatch(
      Operations.openNewPlan({
        planId: 'pro-monthly',
      })
    ),
  getSubscriptions: () => dispatch(Operations.getSubscriptions()),
})

export const CarePlansPaywall = connect<any, any, any>(
  // @ts-ignore
  mapStateToProps,
  mapDispatchToProps
)(CarePlansPaywallComponent)
